import React, { useState, useEffect } from "react";
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import api from "components/api/api";
import "./CreateSurvey.scss";
import { useHistory, useLocation, Link } from "react-router-dom";
import toast from "react-hot-toast";
import ImportModal from "pages/createSurvey/ImportModal";
import PreviewModal from "pages/PreviewModal/PreviewModal";
import UserSelector from "pages/Userselector/Userselector";
const CreateQuiz = ({ t }) => {
  const history = useHistory();
  const location = useLocation();
  const [regionData, setregionData] = useState({});
  const [regionNames, setRegionNames] = useState([]);
  const [maxRetake, setMaxRetake] = useState(1);
  const [visibilityType, setVisibilityType] = useState("public");
  const [showPreview, setShowPreview] = useState(false);
  const [userDataDisplayFields, setUserDataDisplayFields] = useState([
    "username",
    "region",
    "outlet",
    "staffId",
  ]);
  const handlePreview = () => {
    if (questions.length === 0) {
      toast.error("Please add at least one question to preview the quiz.");
      return;
    }
    setShowPreview(true);
  };
  const [announcementMode, setAnnouncementMode] = useState("IMMEDIATE");
  const [scheduledTime, setScheduledTime] = useState("");

  const fetchUsers = async () => {
    try {
      const res = await api.fetchUsers();
      const users = res.data?.data || [];

      const filteredUsers = users.filter((user) => user.role !== "ADMIN");
      const regionData = { "All Regions": {} };

      filteredUsers.forEach((user) => {
        const { id, username, region, outlet } = user;
        if (!region || !outlet || !username) return;

        if (!regionData[region]) regionData[region] = {};
        if (!regionData[region][outlet]) regionData[region][outlet] = [];

        regionData[region][outlet].push({ id, username });
      });
      return { regionData };
    } catch (error) {
      console.error("Error fetching users", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchAndSetregionData = async () => {
      const data = await fetchUsers();
      if (data) {
        setregionData(data.regionData);
        setRegionNames(Object.keys(data.regionData));
      }
    };

    fetchAndSetregionData();
  }, []);

  const [quizTitle, setQuizTitle] = useState("Untitled Quiz");
  const [selectedRegion, setSelectedRegion] = useState("All Regions");
  const [selectedDistrict, setSelectedDistrict] = useState("All Outlet");
  const [districts, setDistricts] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [mandatoryStatus, setMandatoryStatus] = useState("Optional");
  const [quizDuration, setQuizDuration] = useState({ hours: 0, minutes: 0 });
  const [quizTotalDuration, setQuizTotalDuration] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  });

  const [showImportModal, setShowImportModal] = useState(false);

  const [questions, setQuestions] = useState([
    {
      id: 1,
      type: "radiogroup",
      text: "Sample Question?",
      arabicText: "",
      options: ["Option A", "Option B"],
      correctAnswer: "",
      marks: 1,
    },
  ]);

  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0);

  useEffect(() => {
    if (Object.keys(regionData).length === 0) return;

    const allDistricts = Object.values(regionData).flatMap((region) =>
      Object.keys(region || {}),
    );
    const allUsers = Object.values(regionData)
      .flatMap((region) => Object.values(region || {}))
      .flat();

    setDistricts(allDistricts);
    setSelectedDistrict("All Outlet");

    setUserList(allUsers); // allUsers is array of { id, username }
    setSelectedUsers(allUsers.map((u) => u.id)); // store only IDs
  }, [regionData]);

  useEffect(() => {
    const dup = location.state?.duplicateData;
    if (!dup) return;

    setQuizTitle(`${dup.title} (Copy)`);

    // Rebuild questions from definitionJson
    const pages = dup.json?.pages || [];
    const rebuilt = pages
      .flatMap((page) => page.elements || [])
      .map((el, i) => ({
        id: Date.now() + i,
        type: el.type || "radiogroup",
        text: el.title || "Question?",
        arabicText: el.arabicTitle || "",
        options: el.choices || [],
        correctAnswer: el.correctAnswer || "",
        marks: el.marks || 1,
      }));

    if (rebuilt.length > 0) {
      setQuestions(rebuilt);
      setSelectedQuestionIndex(0);
    }

    // Restore total validity duration
    if (dup.minutes) {
      const totalMins = dup.minutes;
      const days = Math.floor(totalMins / 1440);
      const hours = Math.floor((totalMins % 1440) / 60);
      const mins = totalMins % 60;
      setQuizTotalDuration({ days, hours, minutes: mins });
    }

    if (dup.maxRetake !== undefined) setMaxRetake(dup.maxRetake);
    if (dup.visibilityType) setVisibilityType(dup.visibilityType.toLowerCase());
    if (dup.userDataDisplayFields?.length)
      setUserDataDisplayFields(dup.userDataDisplayFields);
  }, [location.state]);

  const handleRegionChange = (region) => {
    setSelectedRegion(region);
    setSelectedUsers([]);

    if (region === "All Regions") {
      // Dynamically get all districts across all regions
      const allDistricts = Object.values(regionData).flatMap((regionObj) =>
        Object.keys(regionObj || {}),
      );
      // Dynamically get all users across all regions
      const allUsers = Object.values(regionData)
        .flatMap((regionObj) => Object.values(regionObj || {}))
        .flat();

      setDistricts(allDistricts);
      setSelectedDistrict("All Outlet");
      setUserList(allUsers); // allUsers is array of { id, username }
      setSelectedUsers(allUsers.map((u) => u.id)); // store only IDs
    } else {
      const regionDistricts = Object.keys(regionData[region] || {});
      const allUsersInRegion = Object.values(regionData[region] || {}).flat();

      setDistricts(regionDistricts);
      setSelectedDistrict("All Outlet");
      setUserList(allUsersInRegion);
      setSelectedUsers(allUsersInRegion.map((u) => u.id));
    }
  };

  const handleDistrictChange = (district) => {
    setSelectedDistrict(district);

    if (district === "All Outlet") {
      if (selectedRegion === "All Regions") {
        // Dynamically get all users across all regions
        const allUsers = Object.values(regionData)
          .flatMap((regionObj) => Object.values(regionObj || {}))
          .flat();
        setUserList(allUsers); // allUsers is array of { id, username }
        setSelectedUsers(allUsers.map((u) => u.id)); // store only IDs
      } else {
        const users = Object.values(regionData[selectedRegion] || {}).flat();
        setUserList(users); // allUsers is array of { id, username }
        setSelectedUsers(users.map((u) => u.id)); // store only IDs
      }
    } else {
      if (selectedRegion === "All Regions") {
        // Find which region the district belongs to and get users
        const usersInDistrict = Object.values(regionData)
          .flatMap((regionObj) => regionObj[district] || [])
          .flat();
        setUserList(usersInDistrict);
        setSelectedUsers(usersInDistrict);
      } else {
        const users = regionData[selectedRegion]?.[district] || [];
        setUserList(users); // allUsers is array of { id, username }
        setSelectedUsers(users.map((u) => u.id)); // store only IDs
      }
    }
  };

  const handleUserChange = (e) => {
    const { value, checked } = e.target;
    const id = value;

    if (value === "ALL") {
      setSelectedUsers(checked ? userList.map((u) => u.id) : []);
    } else {
      setSelectedUsers((prev) =>
        checked ? [...prev, id] : prev.filter((uid) => uid !== id),
      );
    }
  };

  const handleAddQuestion = () => {
    const newQuestion = {
      id: Date.now(),
      type: "radiogroup",
      text: "New Question?",
      arabicText: "",
      options: [],
      correctAnswer: "",
      marks: 1,
    };
    setQuestions([...questions, newQuestion]);
    setSelectedQuestionIndex(questions.length);
  };

  const handleDeleteQuestion = () => {
    const updated = [...questions];
    updated.splice(selectedQuestionIndex, 1);
    setQuestions(updated);

    if (updated.length === 0) {
      setSelectedQuestionIndex(-1); // or null
    } else if (selectedQuestionIndex >= updated.length) {
      setSelectedQuestionIndex(updated.length - 1);
    }
  };

  const handleOptionChange = (value, optIndex) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].options[optIndex] = value;
    setQuestions(updated);
  };

  const handleAddOption = () => {
    const updated = [...questions];
    updated[selectedQuestionIndex].options.push("New Option");
    setQuestions(updated);
  };

  const handleDeleteOption = (optIndex) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].options.splice(optIndex, 1);
    setQuestions(updated);
  };

  const handleTitleChange = (value) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].text = value;
    setQuestions(updated);
  };

  const handleArabicTitleChange = (value) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].arabicText = value;
    setQuestions(updated);
  };

  const handleCorrectAnswerChange = (value) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].correctAnswer = value;
    setQuestions(updated);
  };

  const handleTypeChange = (value) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].type = value;
    updated[selectedQuestionIndex].options = [
      "text",
      "rating",
      "boolean",
    ].includes(value)
      ? []
      : [];
    updated[selectedQuestionIndex].correctAnswer =
      value === "checkbox" ? [] : "";
    setQuestions(updated);
  };

  const handleMarksChange = (value) => {
    const updated = [...questions];
    updated[selectedQuestionIndex].marks = parseInt(value) || 0;
    setQuestions(updated);
  };

  const transformToQuizModel = () => {
    const elements = questions.map((q, index) => ({
      type: q.type,
      name: `q${index + 1}`,
      title: q.text,
      arabicTitle: q.arabicText,
      choices: ["radiogroup", "checkbox", "dropdown", "boolean"].includes(
        q.type,
      )
        ? q.options?.filter((opt) => opt?.trim() !== "")
        : undefined,
      marks: q.marks || 0,
      correctAnswer: q.correctAnswer,
    }));

    const answerKey = {};
    questions.forEach((q, i) => {
      answerKey[`q${i + 1}`] = q.correctAnswer;
    });

    const totalquizMinutes =
      parseInt(quizTotalDuration.days || 0) * 1440 +
      parseInt(quizTotalDuration.hours || 0) * 60 +
      parseInt(quizTotalDuration.minutes || 0);

    const quizMinutes =
      parseInt(quizDuration.days || 0) * 1440 +
      parseInt(quizDuration.hours || 0) * 60 +
      parseInt(quizDuration.minutes || 0);

    return {
      type: "Quiz",
      title: quizTitle,
      definitionJson: { pages: [{ elements }] },
      status: true,
      quizTotalDuration: totalquizMinutes,
      quizDuration: quizMinutes,
      isMandatory: mandatoryStatus === "Mandatory",
      answerKey,
      maxScore: questions.reduce((acc, q) => acc + (q.marks || 0), 0),
      targetedUsers: selectedUsers,
      maxRetake: maxRetake,

      // ✅ new fields
      visibilityType,
      userDataDisplayFields,
      announcementMode,
      scheduledTime,
    };
  };

  const handlePublish = async () => {
    const model = transformToQuizModel();
    try {
      await api.publishQuiz(model);
      toast.success("Quiz published successfully!");
      history.push("/quiz-survey");
    } catch (error) {
      console.error("Error publishing quiz:", error);
      toast.error("Failed to publish quiz.");
    }
  };
  const handleImportQuestions = () => {
    setShowImportModal(true);
  };
  const handleImport = async (formData) => {
    try {
      const res = await api.importQuestions(formData);
      setQuestions(res.data.questions || []);
    } catch (error) {
      throw error; // let ImportModal show toast error
    }
  };

  const handleScheduledTimeChange = (e) => {
    const localDateTime = e.target.value; // "2025-09-26T06:42"
    const date = new Date(localDateTime); // local time
    const utcIsoString = date.toISOString(); // "2025-09-26T06:42:00.000Z"
    setScheduledTime(utcIsoString);
  };

  return (
    <>
      <Breadcrumb title={t("Create Quiz")} />
      <div className="app-wrapper" style={{}}>
        <div className="animated slideInUpTiny animation-duration-3">
          <div className="row dashboardDetails">
            <div
              className="col-md-12 col-sm-12 col-xs-12"
              style={{ minHeight: "100vh", height: "auto" }}
            >
              <div className="create-survey">
                <aside className="sidebar card">
                  <input
                    className="survey-title-input"
                    value={quizTitle}
                    onChange={(e) => setQuizTitle(e.target.value)}
                    placeholder="Quiz Title"
                  />
                  <button
                    className="new-question-btn"
                    onClick={handleAddQuestion}
                  >
                    NEW QUESTION <span className="plus">+</span>
                  </button>
                  <div className="question-list">
                    {questions.map((q, i) => (
                      <div
                        key={q.id}
                        className={`question-title ${
                          i === selectedQuestionIndex ? "active" : ""
                        }`}
                        onClick={() => setSelectedQuestionIndex(i)}
                      >
                        {q.text}
                      </div>
                    ))}
                  </div>
                </aside>
                {selectedQuestionIndex !== -1 && questions.length > 0 ? (
                  <main className="question-editor">
                    <div className="region-user-card card">
                      <div className="region-user-selectors">
                        <UserSelector
                          regionData={regionData}
                          selectedUsers={selectedUsers}
                          onChange={setSelectedUsers}
                        />

                        <div className="mandatory-dropdown">
                          <label>Quiz Mode:</label>
                          <select
                            value={mandatoryStatus}
                            onChange={(e) => setMandatoryStatus(e.target.value)}
                          >
                            <option value="Optional">Optional</option>
                            <option value="Mandatory">Mandatory</option>
                          </select>
                          <div className="time-cont">
                            <div className="duration-input">
                              <label>⏰ Quiz Duration (HH:MM):</label>
                              <div>
                                <input
                                  type="number"
                                  min="0"
                                  max="23"
                                  value={quizDuration.hours}
                                  onChange={(e) =>
                                    setQuizDuration({
                                      ...quizDuration,
                                      hours: Number(e.target.value) || 0,
                                    })
                                  }
                                  className="inputStyle"
                                />
                                <input
                                  type="number"
                                  min="0"
                                  max="59"
                                  value={quizDuration.minutes}
                                  onChange={(e) =>
                                    setQuizDuration({
                                      ...quizDuration,
                                      minutes: Number(e.target.value) || 0,
                                    })
                                  }
                                  className="inputStyle"
                                />
                              </div>
                            </div>
                            <div className="duration-input">
                              <label>⏰ Validity (Days:HH:MM):</label>
                              <div>
                                <input
                                  type="number"
                                  min="0"
                                  value={quizTotalDuration.days}
                                  onChange={(e) =>
                                    setQuizTotalDuration({
                                      ...quizTotalDuration,
                                      days: Number(e.target.value) || 0,
                                    })
                                  }
                                  className="inputStyle"
                                />
                                <span>:</span>
                                <input
                                  type="number"
                                  min="0"
                                  max="23"
                                  value={quizTotalDuration.hours}
                                  onChange={(e) =>
                                    setQuizTotalDuration({
                                      ...quizTotalDuration,
                                      hours: Number(e.target.value) || 0,
                                    })
                                  }
                                  className="inputStyle"
                                />
                                <span>:</span>
                                <input
                                  type="number"
                                  min="0"
                                  max="59"
                                  value={quizTotalDuration.minutes}
                                  onChange={(e) =>
                                    setQuizTotalDuration({
                                      ...quizTotalDuration,
                                      minutes: Number(e.target.value) || 0,
                                    })
                                  }
                                  className="inputStyle"
                                />
                              </div>
                            </div>

                            <div className="duration-input">
                              <label> Max Re-attempt:</label>
                              <div>
                                <input
                                  type="number"
                                  min="0"
                                  max="5"
                                  value={maxRetake}
                                  onChange={(e) =>
                                    setMaxRetake(Number(e.target.value) || 0)
                                  }
                                  className="inputStyle"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="duration-input">
                            <label>Visibility Type:</label>
                            <select
                              value={visibilityType}
                              onChange={(e) =>
                                setVisibilityType(e.target.value)
                              }
                            >
                              <option value="public">Public</option>
                              <option value="private">Private</option>
                            </select>
                          </div>

                          <div className="duration-input">
                            <label>User Data Fields:</label>
                            <div className="user-data-fields">
                              {["username", "region", "outlet", "staffId"].map(
                                (field) => (
                                  <label key={field}>
                                    <input
                                      type="checkbox"
                                      value={field}
                                      checked={userDataDisplayFields.includes(
                                        field,
                                      )}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        setUserDataDisplayFields((prev) =>
                                          checked
                                            ? [...prev, field]
                                            : prev.filter((f) => f !== field),
                                        );
                                      }}
                                    />
                                    {field}
                                  </label>
                                ),
                              )}
                            </div>
                          </div>

                          <div className="duration-input">
                            <label>Announcement Mode:</label>
                            <select
                              value={announcementMode}
                              onChange={(e) =>
                                setAnnouncementMode(e.target.value)
                              }
                            >
                              <option value="IMMEDIATE">Immediate</option>
                              <option value="SCHEDULED">Scheduled</option>
                            </select>
                          </div>

                          {announcementMode === "SCHEDULED" && (
                            <div className="duration-input">
                              <label>Scheduled Time:</label>
                              <input
                                type="datetime-local"
                                value={
                                  scheduledTime
                                    ? scheduledTime.slice(0, 16)
                                    : ""
                                }
                                onChange={handleScheduledTimeChange}
                                className="inputStyleTime"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="question-card card">
                      <div className="editor-header">
                        <input
                          className="question-title-input"
                          type="text"
                          value={questions[selectedQuestionIndex].text}
                          onChange={(e) => handleTitleChange(e.target.value)}
                        />
                        <input
                          className="question-title-input"
                          type="text"
                          dir="rtl"
                          placeholder="Arabic Question Text"
                          value={questions[selectedQuestionIndex].arabicText}
                          onChange={(e) =>
                            handleArabicTitleChange(e.target.value)
                          }
                        />
                        <select
                          className="question-type-select"
                          value={questions[selectedQuestionIndex].type}
                          onChange={(e) => handleTypeChange(e.target.value)}
                        >
                          <option value="radiogroup">Radio</option>
                          <option value="checkbox">Checkbox</option>
                          <option value="dropdown">Dropdown</option>
                          <option value="text">Text</option>
                          <option value="boolean">Boolean</option>
                        </select>
                        <button
                          className="delete-question-btn"
                          onClick={handleDeleteQuestion}
                        >
                          ❌ DELETE QUESTION
                        </button>
                      </div>

                      <div className="options-list">
                        {/* Option-based types */}
                        {["radiogroup", "checkbox", "dropdown"].includes(
                          questions[selectedQuestionIndex].type,
                        ) &&
                          questions[selectedQuestionIndex].options.map(
                            (opt, i) => (
                              <div className="option-row" key={i}>
                                <span className="drag-icon">≡</span>
                                <input
                                  type="text"
                                  value={opt}
                                  onChange={(e) =>
                                    handleOptionChange(e.target.value, i)
                                  }
                                />
                                <button
                                  className="delete-opt-btn"
                                  onClick={() => handleDeleteOption(i)}
                                >
                                  ❌
                                </button>
                              </div>
                            ),
                          )}

                        {/* Add Option Button */}
                        {["radiogroup", "checkbox", "dropdown"].includes(
                          questions[selectedQuestionIndex].type,
                        ) && (
                          <button
                            className="add-option-btn"
                            onClick={handleAddOption}
                          >
                            ADD <span className="plus">+</span>
                          </button>
                        )}

                        {/* Text Input Preview */}
                        {questions[selectedQuestionIndex].type === "text" && (
                          <div className="review-preview">
                            <label>Preview:</label>
                            <input
                              type="text"
                              className="text-input-preview"
                              placeholder="Your answer here..."
                              disabled
                            />
                          </div>
                        )}

                        {/* Comment Box Preview */}
                        {questions[selectedQuestionIndex].type ===
                          "comment" && (
                          <div className="review-preview">
                            <label>Preview:</label>
                            <textarea
                              className="comment-preview"
                              placeholder="Write your comments here..."
                              disabled
                            />
                          </div>
                        )}

                        {/* Rating Stars Preview */}
                        {questions[selectedQuestionIndex].type === "rating" && (
                          <div className="review-preview">
                            <label>Preview:</label>
                            <div className="star-rating-preview">
                              {[...Array(5)].map((_, i) => (
                                <span
                                  key={i}
                                  style={{ color: "#FFD700", fontSize: "24px" }}
                                >
                                  ★
                                </span>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Boolean Preview */}
                        {questions[selectedQuestionIndex].type ===
                          "boolean" && (
                          <div className="review-preview">
                            <label>Preview:</label>
                            <div className="boolean-preview">
                              <label>
                                <input type="radio" disabled /> Yes
                              </label>
                              <label style={{ marginLeft: "10px" }}>
                                <input type="radio" disabled /> No
                              </label>
                            </div>
                          </div>
                        )}

                        {/* HTML Content Preview */}
                        {questions[selectedQuestionIndex].type === "html" && (
                          <div className="review-preview">
                            <label>Preview:</label>
                            <div className="html-preview">
                              <em>
                                This is a static HTML content block. No input
                                required.
                              </em>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="CorrectAnswerContainer">
                        <div className="correct-answer-section">
                          <label>Correct Answer:</label>
                          {questions[selectedQuestionIndex].type ===
                          "checkbox" ? (
                            questions[selectedQuestionIndex].options.map(
                              (opt, i) => (
                                <label key={i}>
                                  <input
                                    type="checkbox"
                                    checked={
                                      Array.isArray(
                                        questions[selectedQuestionIndex]
                                          .correctAnswer,
                                      ) &&
                                      questions[
                                        selectedQuestionIndex
                                      ].correctAnswer.includes(opt)
                                    }
                                    onChange={(e) => {
                                      const updatedAnswers = Array.isArray(
                                        questions[selectedQuestionIndex]
                                          .correctAnswer,
                                      )
                                        ? [
                                            ...questions[selectedQuestionIndex]
                                              .correctAnswer,
                                          ]
                                        : [];
                                      if (e.target.checked) {
                                        updatedAnswers.push(opt);
                                      } else {
                                        const index =
                                          updatedAnswers.indexOf(opt);
                                        if (index !== -1)
                                          updatedAnswers.splice(index, 1);
                                      }
                                      const updated = [...questions];
                                      updated[
                                        selectedQuestionIndex
                                      ].correctAnswer = updatedAnswers;
                                      setQuestions(updated);
                                    }}
                                  />
                                  {opt}
                                </label>
                              ),
                            )
                          ) : (
                            <input
                              type="text"
                              value={
                                questions[selectedQuestionIndex].correctAnswer
                              }
                              onChange={(e) =>
                                handleCorrectAnswerChange(e.target.value)
                              }
                            />
                          )}
                        </div>

                        <div className="marks-section">
                          <label>
                            Marks:
                            <input
                              type="number"
                              value={questions[selectedQuestionIndex].marks}
                              onChange={(e) =>
                                handleMarksChange(e.target.value)
                              }
                              min={0}
                            />
                          </label>
                        </div>
                      </div>

                      <div className="DurationContainer">
                        <div className="action-buttons">
                          {/* <button
                            className="publish-btn"
                            onClick={handleImportQuestions}
                          >
                            Import Questions
                          </button> */}
                          <button
                            className="preview-btn"
                            onClick={handlePreview}
                            style={{
                              backgroundColor: "#6B7280",
                              color: "white",
                              border: "none",
                              padding: "10px 20px",
                              borderRadius: "5px",
                              cursor: "pointer",
                              marginRight: "10px",
                            }}
                          >
                            Preview Quiz
                          </button>
                          <button
                            className="publish-btn"
                            onClick={handlePublish}
                          >
                            Publish Quiz
                          </button>
                        </div>
                      </div>
                    </div>
                  </main>
                ) : (
                  <div className="no-questions-message">
                    No questions available. Please add a question.
                    {/* <button
                      className="publish-btn"
                      onClick={handleImportQuestions}
                    >
                      Import Questions
                    </button> */}
                  </div>
                )}
                <ImportModal
                  show={showImportModal}
                  onClose={() => setShowImportModal(false)}
                  onImport={handleImport}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <PreviewModal
        show={showPreview}
        onClose={() => setShowPreview(false)}
        quizTitle={quizTitle}
        questions={questions}
        quizType="Quiz"
      />
    </>
  );
};

export default translate(CreateQuiz);
